module.exports = __webpack_public_path__ + "static/DigirytePodsNoShadow-0443f88d0a6eac362012bad3e3341a99.png";